import { navigate } from "gatsby";
import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import {ResponsiveSliderTop}  from "../../../../utils/constant";

const Layout_1 =({item})=>{
    const handleClick=(uri)=>{
        if(uri.includes('bibomart://landing-page') === true){
            window.location.href = uri.replaceAll('bibomart://landing-page?id=','/page/landing-page.html?');
        }else{
            navigate(uri);
        }
    }
    return(
    <div className="row mgt-5" id="banner-list">
        <div style={{overflow:'hidden'}}>
        {  
            item.length>0 && item.length>1?(
                <Carousel key=""
                    responsive={ResponsiveSliderTop}
                    showDots={true}
                    autoPlay={true}
                    autoPlaySpeed={3000}
                    infinite={true}
                    >
                    {
                        item.map((_item,i)=>{
                            return <div  key={i} className="slider-top">
                                    <img onClick={()=>handleClick(_item.link)} src={_item.images} style={{width: '100%', height:156}}/>
                            </div>
                        })
                    }
                
                </Carousel>
            ):(
                item.length>0?(<div className="slider-top">
                <img onClick={()=>handleClick(item[0].link)} src={item[0].images} style={{width: '100%', height:125}}/>
            </div>):(null)
        )
        }
        </div>
        </div>
    )
}

const Layout_2 =(item)=>{
    const handleClick=(uri)=>{
        if(uri.includes('bibomart://landing-page') === true){
            window.location.href = uri.replaceAll('bibomart://landing-page?id=','/page/landing-page.html?');
        }else{
            navigate(uri);
        }
    }
    return(
        <div className="row mgt-5" id="banner-list">
        <div style={{height:125, overflow:'hidden'}}>
        {  
           item?.item?.length>0 && item?.item?.length>1?(
                <Carousel key="banner-layout-2"
                    responsive={ResponsiveSliderTop}
                    showDots={true}
                    autoPlay={true}
                    autoPlaySpeed={3000}
                    infinite={true}
                    >
                    {
                        item?.item?.map((_item,i)=>{
                            return <div  key={i} className="slider-top">
                                    <img onClick={()=>handleClick(_item.link)} src={_item.images} style={{width: '100%', height:125}}/>
                            </div>
                        })
                    }
                
                </Carousel>
            ):(item?.item?.length>0?(<div className="slider-top">
                    <img onClick={()=>handleClick(item.item[0].link)} src={item.item[0].images} style={{width: '100%', height:125}}/>
                </div>):(null))
        }
        </div>
        </div>
    )
}

export {Layout_1, Layout_2};